import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Register from './pages/Register';
import Home from './pages/Home';
import Setup from './pages/Setup';
import LiveInterview from './pages/LiveInterview';
import History from './pages/History';
import Callback from './pages/Callback';
import ForgotPassword from './pages/ForgotPassword';
import LivePresentation from './pages/LivePresentation';
import PresentationSetup from './pages/PresentationSetup';
import Scorecard from './pages/Scorecard';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/home" element={<Home />} />
        <Route path="/setup" element={<Setup />} />
        <Route path="/live-interview" element={<LiveInterview />} />
        <Route path="/history" element={<History />} />
        <Route path="/callback" element={<Callback />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/presentation-setup" element={<PresentationSetup />} />
        <Route path="/live-presentation" element={<LivePresentation />} />
        <Route path="/scorecard/:sessionId" element={<Scorecard />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;